import { render, staticRenderFns } from "./AfzalIcon.vue?vue&type=template&id=d85af232"
import script from "./AfzalIcon.vue?vue&type=script&lang=js"
export * from "./AfzalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports